import { jsx as e } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import n from "../../utils/classNames.js";
const i = m((o, r) => {
  const { className: s, children: a, ...t } = o, c = n("ActionBarItemIcon", s);
  return /* @__PURE__ */ e("div", { ...t, className: c, ref: r, children: a });
});
i.displayName = "ActionBarItemIcon";
export {
  i as default
};
//# sourceMappingURL=ActionBarItemIcon.js.map
